import React from 'react'
import Widgets from '../../elem/widgets/Widgets'

export default () => (
    <div className="pageWrapper">
        <Widgets />
    </div>
)
